import React from "react"
import { Link } from "react-router-dom"
import Nav from "./Nav"

export default function Dashboard({ user }) {
  const REPORTS = [
    {
      name: "Calendly Event Attribution",
      description: "Invitee counts grouped by UTM source",
      path: "/reports/calendly-attribution"
    },
    {
      name: "Builders Risk Submissions",
      description: "View and manage all builders risk submissions with pagination",
      path: "/reports/builders-risk-submissions"
    },
    {
      name: "Insurance Quote Submissions",
      description: "View and manage all insurance quote submissions with pagination",
      path: "/reports/insurance-quote-submissions"
    },
    {
      name: "Restaurant Insurance Submissions",
      description: "View and manage all restaurant insurance quote submissions with pagination",
      path: "/reports/restaurant-insurance-submissions"
    },
    {
      name: "Workers Compensation Submissions",
      description: "View and manage all workers compensation quote submissions with pagination",
      path: "/reports/workers-compensation-submissions"
    },
    {
      name: "Commercial Auto Insurance Submissions",
      description: "View and manage all commercial auto insurance submissions with pagination",
      path: "/reports/commercial-auto-insurance-submissions"
    }
  ]


  return (
    <div className="min-h-screen bg-gray-100">
      <Nav user={user} />

      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="bg-white rounded-lg shadow px-5 py-6 sm:px-6">
          <h2 className="text-2xl font-bold text-gray-900">Dashboard</h2>
          <p className="mt-2 text-gray-600">Welcome, {user.name}!</p>
        </div>

<div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="px-5 py-6 sm:px-6 border-b border-gray-200">
            <h3 className="text-xl font-bold text-gray-900">Reports</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Report</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Description</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {REPORTS.map((report) => (
                  <tr key={report.path} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <Link to={report.path} className="text-blue-600 hover:text-blue-700 font-medium">
                        {report.name}
                      </Link>
                    </td>
                    <td className="px-6 py-4 text-gray-600">{report.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
